import React, { useMemo } from "react";
import { Text } from "@salestrak/ui";
import type { EntityData } from "#app/lib/entity-visuals";
import type { ActivityChange } from "../activity-types";
import { pluralize } from "../activity-utils";
import { MAX_DISPLAY_COUNT } from "../activity-types";
import { EntityNames } from "./assignee-chunk";

/** The Teams property: "added team Roofers", "removed teams A and B". */
export function TeamsChunk({ change }: { change: ActivityChange }) {
  const entities = useMemo<EntityData[]>(
    () => (change.teams ?? []).map((team) => ({ kind: "team" as const, id: team.teamId, team })),
    [change.teams],
  );
  const noun = pluralize("team", { count: entities.length });

  if (entities.length === 0) return null;
  if (entities.length > MAX_DISPLAY_COUNT) {
    return (
      <Text size="sm">
        {change.action} {entities.length} {noun}
      </Text>
    );
  }
  return (
    <Text size="sm">
      {change.action} {noun}
      <EntityNames entities={entities} />
    </Text>
  );
}
